import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    Avatar,
    Button,
    TextField,
    Box,
    Typography,
    Container,
    Alert,
    CircularProgress
} from "@mui/material";
import SarLogo from "assets/sar-logo.png";
import { useNavigate } from "react-router-dom";

import { loginUser } from "store/authReducer";


const Login = () => {
    const dispatch = useDispatch();
    const { loading, error, user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [form, setForm] = useState({})

    useEffect(() => {
        if (user) {
            navigate("/");
        }
    }, [user]);

    const setNewValue = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(loginUser(form));
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                }}
            >
                <Avatar
                    sx={{ m: 1, width: 150, height: 150, bgcolor: "transparent" }}>
                    <img
                        src={SarLogo}
                        alt="SAR"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain"
                        }}
                    />
                </Avatar>


                <Typography component="h1" variant="h5">
                    Iniciar sesión
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ mt: 2, width: "100%" }}>
                        {error}
                    </Alert>
                )}

                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        label="Cuenta"
                        name="account"
                        autoComplete="account"
                        autoFocus
                        value={form.account}
                        onChange={setNewValue}
                    />

                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="email"
                        label="Correo electrónico"
                        autoComplete="email"
                        autoFocus
                        value={form.email}
                        onChange={setNewValue}
                    />

                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Contraseña"
                        type="password"
                        autoComplete="current-password"
                        value={form.password}
                        onChange={setNewValue}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                        disabled={loading}
                    >
                        {loading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            "Entrar"
                        )}
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};

export default Login;
